import MyCheckboxGroup from './checkboxGroup';

MyCheckboxGroup.install = function(Vue){
  Vue.component('MyCheckboxGroup', MyCheckboxGroup);
};

export default MyCheckboxGroup;